import {React, Component, Container, Link, _} from 'utils';
import { SelectedPavilionStore, FairStore, App } from 'model';
import './pavilionmenu.less';

class PavilionMenu extends Component {

	static getStores() {
		return [SelectedPavilionStore, FairStore];
	}

	static calculateState() {
		return {
			pavilions: FairStore.getPavilions(),
			selected: SelectedPavilionStore.getSelectedPavilionSlug()
		};
	}

	render() {

		var { pavilions, selected } = this.state;

		var view = null;

		let activePavilion = null;

		if(pavilions) {
			view = pavilions.map((item) => {
				var css = ['link'];
				var overlay = null;

				if (item.slug == selected)
				{
					css.push('active');
					overlay = <div className="overlay"></div>
					activePavilion = (
						<span>
							<span className="label">{_('Pavilion')}:</span>
							<span className="name">{item.name}</span>
						</span>
					);
				}

				var url = App.pavilionUrl(item);

				let description = item.description ? <span className="description">{ item.description }</span> : null;

				return <div key={item.slug} className={ css.join(' ') }>
					<Link to={ url }>
						<img src={ item.imageUrl } />
						<span className="icon"></span>
						<span className="title">
							<span className="name">{ item.name }</span>
							{description}
							{item.poweredByLogo &&
								<div className="poweredby">
									{_('Powered by')}
									<span onClick={() => {
											window.open(item.poweredByLink, '_blank').focus();
										}}>
										<img alt={item.poweredByTitle} src={item.poweredByLogoUrl}/>
									</span>
								</div>
							}
						</span>
					</Link>
					{ overlay }
				</div>
			});
		}

		return <div className="pavilion-menu">
			<div className="pavilion-menu-items">
				{ view }
			</div>
			<div className="active-pavilion">
				{ activePavilion }
			</div>
		</div>;
	}
}

export default Container.create(PavilionMenu);


// WEBPACK FOOTER //
// ./src/modules/components/pavilionmenu.js